import {ref} from 'vue'
import {defineStore} from 'pinia'

export const useNotifyStore = defineStore('notifications', () => {
	const notifications = ref([])

	function add(payload, type) {
		const {title = '', message = '', offset = 0, onClick, onClose, dangerouslyUseHTMLString, duration} = payload
		const timeout = duration === undefined ? (type === 'error' ? 10000 : 4500) : duration
		const notification = {
			id: parseInt(Math.random() * 10000),
			title,
			message,
			offset,
			onClick,
			onClose,
			type,
			dangerouslyUseHTMLString,
		}
		notifications.value.unshift(notification)
		if (timeout !== 0) {
			setTimeout(remove, timeout, notification.id)
		}
		return notification
	}
	function info(payload) {
		return add(payload, 'info')
	}
	function success(payload) {
		return add(payload, 'success')
	}
	function warn(payload) {
		return add(payload, 'warning')
	}
	function error(payload) {
		return add(payload, 'error')
	}
	function remove(id) {
		notifications.value = notifications.value.filter(item => item.id !== id)
	}

	return {
		notifications,
		info,
		success,
		warn,
		error,
		remove,
	}
})
